<template>
	<div>
		<div class="row">
			<div class="col-md-4 mb-4">
				<info-card
					:title="'Ticket Médio'"
					icon="fa-shopping-cart"
					variant="success"
					:value="averageTicket.ticket_purchased"
				/>
			</div>
			<div class="col-md-4 mb-4">
				<info-card
					:title="'Média de atraso '"
					icon="fa-calendar"
					variant="danger"
					:value="overDueAverage"
				/>
			</div>
			<div class="col-md-4 mb-4">
				<info-card
					:title="'Total de Compras'"
					icon="fa-file-invoice-dollar"
					variant="primary"
					:value="averageTicket.total_purchased"
				/>
			</div>
		</div>

		<table-paginator :data="bills" @pagechange="select($event)">
			<div class="row grid-table-heading d-md-flex d-none">
				<div class="col-md-6">Descrição</div>
				<div class="col-md-6">
					<div class="row">
						<div class="col-3 text-right">Valor Original</div>
						<div class="col-3 text-right">Dias de Atraso</div>
						<div class="col-3 text-right">Vencimento</div>
						<div class="col-3 text-right">Status</div>
					</div>
				</div>
			</div>
			<hr />

			<template v-for="row in bills.data">
				<div
					class="row grid-table-row align-items-md-center align-items-start"
					@click.stop="openBillReceivebleDetails(row)"
					:key="row.id"
				>
					<div class="col-8 col-md-6 d-flex">
            <div>
              <b-dropdown variant="transparent"
                toggle-class="text-decoration-none"
                no-caret>
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v text-muted" />
                </template>
                <b-dropdown-item @click.stop="printReceipt(row)">
                  <i class="fas fa-print" />
                  Imprimir Recibo
                </b-dropdown-item>
              </b-dropdown>
            </div>
						<div class="ml-2">
							<span>Documento: {{ row.document }}</span>
							<br />
							<small class="text-muted">Ver Compra</small>
						</div>
					</div>

					<div class="col-4 col-md-6">
						<div class="row">
							<div class="col-md-3 text-right d-none d-md-inline">
								{{ row.value | decimal }}
							</div>
							<div class="col-md-3 text-right">
								<b>{{ row.due_days }}</b>
							</div>
							<div class="col-md-3 text-right">
								<due-date-badge ref="DueDateBadge" :date="row.due_date" />
							</div>
							<div class="col-md-3 text-right">
								<span
									:class="['badge', 'text-white', status[row.status].class]"
									style="line-height:1.2"
									>{{ status[row.status].text }}</span
								>
							</div>
						</div>
					</div>
				</div>
			</template>
		</table-paginator>
		<bill-receiveble-details ref="billReceivebleDetails" />
	</div>
</template>

<script>
	import Filters from "../../../mixins/Filters";
	import moment from "moment";
import TablePaginator from '../../sections/TablePaginator.vue';
import InfoCard from '../../sections/dashboard/InfoCard.vue';
	import BillReceivebleDetails from "../sections/BillReceivebleDetails";
	import DueDateBadge from '../../ui/DueDateBadge.vue';

	export default {
		props: {
			id: {}
		},

		components: {
			TablePaginator,
			InfoCard,
			BillReceivebleDetails,
			DueDateBadge
		},

		data: function () {
			return {
				selected: [],

				searchForm: {
					id: null,
					name: null,
					status: "p"
				},

				bills: {},

				overDueAverage: {},

				averageTicket: {},

				status: {
					o: {
						text: "Aberto",
						class: "badge-primary"
					},

					p: {
						text: "Pago",
						class: "badge-success"
					},

					c: {
						text: "Cancelado",
						class: "badge-danger"
					},

					r: {
						text: "Renegociado",
						class: "badge-warning"
					}
				}
			};
		},

		created() {
			this.searchForm.id = this.id;

			this.$store.commit("pageHasLoaded");
			axios
				.post("api/billreceiveble/selectstatuspayed", this.searchForm)
				.then(response => {
					this.bills = response.data.payed;
					this.averageTicket = response.data.averageTicket;

					if (response.data.overDueAverage != null) {
						this.overDueAverage = response.data.overDueAverage;
					} else {
						return (this.overDueAverage = 0);
					}
				})
				.catch(error => {
					this.error = error;
				});
		},

		methods: {
			select(page = 1) {
				this.$store.commit("pageHasLoaded");
				axios
					.post("api/billreceiveble/selectstatuspayed?page=" + page, this.searchForm)
					.then(response => {
						this.bills = response.data.payed;
						this.averageTicket = response.data.averageTicket;

						if (response.data.overDueAverage > 0) {
							this.overDueAverage = response.data.overDueAverage;
						} else {
							return (this.overDueAverage = 0);
						}
					})
					.catch(error => {
						this.error = error;
					});
			},

			getWhatsAppLink(bills) {
				let name = bills.name.replace(/ .*/, "");
				let link = "https://api.whatsapp.com/send?phone=+55" + bills.phone_wa;
				let msg =
					"&text=Olá " +
					name +
					", temos um valor em aberto referente a" +
					"sua última compra com a loja " +
					this.$store.state.company.name +
					" Aguardamos você para novas compras e tomar  cafézinho delicioso com a gente.!";

				return link + msg;
			},

			openBillReceivebleDetails(bill) {
				this.$refs.billReceivebleDetails.open(bill);
			},

      printReceipt(bill){
     		window.open("/contasareceber/imprimir-recibo/" + bill.id, "_blank");
      }
		}
	};
</script>

<style>
</style>
